var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9113 6.06979C24.4751 3.21767 22.7676 1.25415 19.9881 0.379884C17.29 -0.465719 14.7398 0.129069 12.6182 2.10692C12.5739 2.14992 12.5369 2.19291 12.5 2.23591C12.4113 2.12842 12.3152 2.02809 12.2117 1.92777C10.7407 0.559037 8.70044 -0.128911 6.61588 0.0502421C4.5387 0.222229 2.65372 1.23982 1.44881 2.83786C-0.731848 5.71865 -0.421381 9.50953 2.18802 12.0463C4.59045 14.3825 7.00026 16.7115 9.41008 19.0405L12.0417 21.5773C12.0934 21.6274 12.1451 21.6704 12.2117 21.7206L12.5443 21.9929L12.8844 21.6776C12.9509 21.6131 13.0174 21.5558 13.0766 21.4984L15.8412 18.8183C18.1845 16.5467 20.5352 14.275 22.8711 11.989C24.5786 10.3193 25.2661 8.32711 24.9113 6.05545V6.06979ZM23.1667 7.89715C22.9745 9.02223 22.4423 10.0112 21.5996 10.8281L12.5074 19.6424L12.4556 19.5923C12.2412 19.3773 12.0269 19.1623 11.8125 18.9545L9.52835 16.7401C7.5251 14.7981 5.52185 12.8561 3.50381 10.9213C1.33054 8.83591 1.19748 5.54666 3.20074 3.43982C4.22823 2.3649 5.61055 1.74861 7.09636 1.71278C7.14071 1.71278 7.18507 1.71278 7.22942 1.71278C8.68566 1.71278 10.068 2.27174 11.1324 3.28933C11.3764 3.52581 11.6203 3.76229 11.8864 4.02744L12.5369 4.66523L12.803 4.39291C12.9509 4.24242 13.0839 4.0991 13.2244 3.95578C13.4979 3.66913 13.7566 3.38966 14.0375 3.13884C15.7155 1.61246 18.2954 1.27565 20.3134 2.3219C22.4053 3.41115 23.5511 5.64698 23.1667 7.89715Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_2385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.fe29f8ea8e6881cac7cc86a23da5aabd.svg";
export { ForwardRef as ReactComponent };